import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, Transition as _Transition, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "header bg-gradient-success py-7 py-lg-8 pt-lg-6" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "header-body text-center mb-7" }
const _hoisted_4 = { class: "row justify-content-center" }
const _hoisted_5 = { class: "col-xl-5 col-lg-6 col-md-8 px-5" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h1", { class: "text-white" }, "Bienvenido!", -1)
const _hoisted_7 = { class: "text-lead text-white" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-bottom separator-skew zindex-100" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    x: "0",
    y: "0",
    viewBox: "0 0 2560 100",
    preserveAspectRatio: "none",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("polygon", {
      class: "fill-default",
      points: "2560 0 2560 100 0 100"
    })
  ])
], -1)
const _hoisted_9 = { class: "container mt--9 pb-5" }
const _hoisted_10 = { class: "row justify-content-center" }
const _hoisted_11 = { class: "col-lg-5 col-md-7" }
const _hoisted_12 = { class: "card bg-secondary border-0 mb-0" }
const _hoisted_13 = { class: "card-header bg-transparent pb-3" }
const _hoisted_14 = { class: "navbar-wrapper" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("img", {
  src: "/img/icons/newLogo.png",
  class: "w-50 mr-4"
}, null, -1)
const _hoisted_16 = {
  key: 0,
  class: "text-muted text-center mt-4 mb-2"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("small", null, "Sign in", -1)
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = {
  key: 0,
  class: "pt-4 pm-1 px-5",
  style: {"animation-duration":"0.3s"}
}
const _hoisted_20 = { class: "card-body px-lg-5 pm-lg-5 pt-md-1" }
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" Login con CallCenter ")
const _hoisted_22 = { class: "text-center" }
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" SIGN IN ")

import { schema as loginSchema } from "@/store/schemas/login.schema";
import { Form } from "vee-validate";
import { ref, watch } from "vue";
import { AuthModule, ILoginForm } from "@/store/modules/Auth";
import { useRouter } from "vue-router";
import { AlertModule } from "@/store/modules/Alert";
import Notification from "@/components/Notification.vue";
import { env } from "@/config/index";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter();
const onlyCallCenter = env.onlyCallcenter ? true : false;
const model = ref({
	agent: "",
	ext: "",
	pass: "",
	loginWithCC: true,
});

watch(
	() => AuthModule.loading,
	(loading, wasLoading) => {
		if (wasLoading && !loading) {
			router.push(env.onlyCallcenter ? "/callcenter" : "/omnichannel");
		}
	}
);
const onSubmit = (values: ILoginForm) => {
	values.loginCallCenter = model.value.loginWithCC;
	if (env.onlyCallcenter) values.loginCallCenter = true;
	AuthModule.apiLogin(values);
};
const onClose = () => {
	AuthModule.resetError();
	AlertModule.shift();
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_base_input = _resolveComponent("base-input")!
  const _component_base_checkbox = _resolveComponent("base-checkbox")!
  const _component_base_button = _resolveComponent("base-button")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("p", _hoisted_7, _toDisplayString(_unref(env).requiredCallcenter
										? !_unref(env).onlyCallcenter
											? `Autenticación de Agente Callcenter - Chatcenter`
											: `Autenticación de Agente Callcenter`
										: `Autenticación de Agente Chatcenter`), 1)
            ])
          ])
        ])
      ]),
      _hoisted_8
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createVNode(_component_router_link, {
                  class: "navbar-brand d-flex justify-content-center",
                  to: "/"
                }, {
                  default: _withCtx(() => [
                    _hoisted_15
                  ]),
                  _: 1
                })
              ])
            ]),
            (!_unref(AuthModule).error || !_unref(AlertModule).error?.text)
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, _hoisted_18))
              : _createCommentVNode("", true),
            _createVNode(_Transition, { name: "fade" }, {
              default: _withCtx(() => [
                (_unref(AuthModule).error && _unref(AlertModule).error?.text)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                      _createVNode(Notification, {
                        text: _unref(AlertModule).error?.text ?? '',
                        type: "danger",
                        icon: "fas fa-exclamation-triangle",
                        onClose: onClose
                      }, null, 8, ["text"])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_20, [
              _createVNode(_unref(Form), {
                "validation-schema": _unref(loginSchema)(),
                onSubmit: _cache[4] || (_cache[4] = (e) => onSubmit(e))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_base_input, {
                    modelValue: model.value.agent,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((model.value.agent) = $event)),
                    alternative: "",
                    name: "username",
                    "addon-left-icon": "ni ni-email-83",
                    placeholder: "Usuario"
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_base_input, {
                    modelValue: model.value.pass,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((model.value.pass) = $event)),
                    alternative: "",
                    name: "password",
                    "addon-left-icon": "ni ni-lock-circle-open",
                    placeholder: "Password",
                    type: "password"
                  }, null, 8, ["modelValue"]),
                  (_unref(env).requiredCallcenter)
                    ? (_openBlock(), _createBlock(_Transition, {
                        key: 0,
                        name: "fadeUp",
                        "leave-active-class": "fadeOutDown"
                      }, {
                        default: _withCtx(() => [
                          _withDirectives(_createVNode(_component_base_input, {
                            modelValue: model.value.ext,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((model.value.ext) = $event)),
                            alternative: "",
                            name: "extension",
                            class: "rotate-icon",
                            type: "number",
                            "addon-left-icon": "fas fa-phone",
                            style: {"animation-duration":"0.3s"},
                            placeholder: "Extensión Agente"
                          }, null, 8, ["modelValue"]), [
                            [_vShow, model.value.loginWithCC]
                          ])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_unref(env).requiredCallcenter)
                    ? (_openBlock(), _createBlock(_component_base_checkbox, {
                        key: 1,
                        name: "loginCallCenter",
                        modelValue: model.value.loginWithCC,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((model.value.loginWithCC) = $event)),
                        disabled: _unref(onlyCallCenter)
                      }, {
                        default: _withCtx(() => [
                          _hoisted_21
                        ]),
                        _: 1
                      }, 8, ["modelValue", "disabled"]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_22, [
                    _createVNode(_component_base_button, {
                      type: "primary",
                      "native-type": "submit",
                      class: "my-4"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_23
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              }, 8, ["validation-schema"])
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})